import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { InputTextModule } from 'primeng/inputtext'
import { SearchboxComponent } from './searchbox.component'
import { ChipModule } from '@stantec/basin/chip'
import { OverlayPanelModule } from 'primeng/overlaypanel'

@NgModule({
  declarations: [SearchboxComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    ChipModule,
    OverlayPanelModule,
  ],
  exports: [SearchboxComponent],
})
export class SearchboxModule {}
